import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
const utility = tokens.componentColors.utility;

export const tonePickerStyleId = 'wb-v2-tone-picker-theme';

const sharedRoot = {
  '--local-tone-trigger-bg': 'transparent',
  '--local-tone-trigger-radius': tokens.radius.sm,
  '--local-tone-dot-size': '16px',
  '--local-tone-dot-radius': tokens.radius.full,
  '--local-tone-overlay-bg': tokens.color.background.primary,
  '--local-tone-overlay-border': tokens.color.border.secondary,
  '--local-tone-overlay-shadow': tokens.shadow.md,
  '--local-tone-overlay-radius': tokens.radius.md,
  '--local-tone-overlay-padding': tokens.spacing.sm,
  '--local-tone-overlay-gap': tokens.spacing.sm,
  '--local-tone-cell-size': '32px',
  '--local-tone-cell-radius': tokens.radius.sm,
  '--local-tone-cell-dot-size': '16px',
  '--local-tone-cell-hover-ring': tokens.color.border.secondary,
  '--local-tone-cell-selected-ring': tokens.color.border.brand,
  '--local-tone-disabled-opacity': '0.5',
};

export const tonePickerBridgeStyles = {
  // Mounted on the host (used by the trigger button).
  'wb-tone-picker': sharedRoot,
  // The overlay is portalled out of the host into the CDK overlay container,
  // so we mount the same vars on the overlay element directly.
  '.wb-tone-overlay': sharedRoot,
  '[data-tone="gray"]':       { '--local-tone-color': utility.gray500,       '--local-tone-soft': utility.gray100,       '--local-tone-strong': utility.gray700 },
  '[data-tone="brand"]':      { '--local-tone-color': utility.brand500,      '--local-tone-soft': utility.brand100,      '--local-tone-strong': utility.brand700 },
  '[data-tone="indigo"]':     { '--local-tone-color': utility.indigo500,     '--local-tone-soft': utility.indigo100,     '--local-tone-strong': utility.indigo700 },
  '[data-tone="fuchsia"]':    { '--local-tone-color': utility.fuchsia500,    '--local-tone-soft': utility.fuchsia100,    '--local-tone-strong': utility.fuchsia700 },
  '[data-tone="pink"]':       { '--local-tone-color': utility.pink500,       '--local-tone-soft': utility.pink100,       '--local-tone-strong': utility.pink700 },
  '[data-tone="purple"]':     { '--local-tone-color': utility.purple500,     '--local-tone-soft': utility.purple100,     '--local-tone-strong': utility.purple700 },
  '[data-tone="orangeDark"]': { '--local-tone-color': utility.orangeDark500, '--local-tone-soft': utility.orangeDark100, '--local-tone-strong': utility.orangeDark700 },
  '[data-tone="blueLight"]':  { '--local-tone-color': utility.blueLight500,  '--local-tone-soft': utility.blueLight100,  '--local-tone-strong': utility.blueLight700 },
  '[data-tone="moss"]':       { '--local-tone-color': utility.moss500,       '--local-tone-soft': utility.moss100,       '--local-tone-strong': utility.moss700 },
};
